import {
  getApiV1ThreeLetterCodePartnerAdminsContractPlans,
  getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlans200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** パートナーの 3 文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  /** 契約プラン一覧データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsContractPlans200;
};

type IUseGetPartnerAdminsContractPlans = (args: Args) => ReturnType;

/**
 * パートナー管理者用契約プラン一覧取得フック
 *
 * - フォームの選択肢として使用するため絞り込みなし・全件取得
 * - 廃止済みプランのフィルタリングは呼び出し側の converter で行う
 *
 * NOTE: 契約プラン一覧 API はページネーションされるが、本フックはクエリ未指定のため
 * 1 ページ目のみ取得する。プラン数がページサイズを超えると選択肢から漏れる（PEN-1258）。
 * 恒久対応（`useFetchInfinite` での全ページ取得等）は別チケットで対応すること。
 */
export const useGetPartnerAdminsContractPlans: IUseGetPartnerAdminsContractPlans = ({
  threeLetterCode,
}) => {
  const { data } = useFetch<GetApiV1ThreeLetterCodePartnerAdminsContractPlans200>(
    getGetApiV1ThreeLetterCodePartnerAdminsContractPlansKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsContractPlans(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
